import React from "react";
import Header from "@/components/sections/Header";
import Footer from "@/components/sections/Footer";

export default function PageShell({ children, hideHeader = false, hideFooter = false }) {
    return (
        <main className="bg-[#0A1547] text-[#F3F4F6] min-h-screen flex flex-col">
            {!hideHeader && <Header />}
            <div className="flex-1">{children}</div>
            {!hideFooter && <Footer />}
        </main>
    );
}
